import { render } from "./AccountCreditsHistory.vue?vue&type=template&id=e4dd4ff4"
import script from "./AccountCreditsHistory.vue?vue&type=script&lang=js"
export * from "./AccountCreditsHistory.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QTable from 'quasar/src/components/table/QTable.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBanner,QTable});
